import {
  type AcademyAdditionalDataBody,
  academyApi,
  type AcademyInitializationBody,
  type AcademyInitializationUpdateBody,
  type AcademyMetadataItemBody,
  type AcademyUpdateBody,
  type FreePremiumBody,
  type NiceEncodeInfoParams,
} from '@mathflat/domain/Academy'
import { podSettlementApi } from '@mathflat/domain/PodSettlement'

import { Academy } from '@/dto'
import commonRepo from '@/repository/common.repo'

class AcademyController {
  async fetchMyAcademy() {
    const academy = await academyApi.getAcademyDetail({
      mp_event_name: 'T81-02_학원정보가져오기_API',
    })
    return new Academy(academy)
  }

  async changeMyAcademy(academy: Academy) {
    await academyApi.updateAcademy(
      {
        name: academy.name,
        email: academy.email,
        address: academy.address,
        addressDetail: academy.addressDetail,
        zipCode: academy.zipCode,
      },
      { mp_event_name: 'T21-02_학원정보수정_API' },
    )
  }

  async changeMyAcademyLogo(form: FormData) {
    await academyApi.updateAcademyLogo(form, { mp_event_name: 'T21-04_로고수정_API' })
  }

  // 고객 정보 수정과 같은 요청이지만 4주간만 띄우는 고객 분류 팝업이 분류만 보낸다
  async changeCustomerType(body: Pick<AcademyUpdateBody, 'customerType'>) {
    await academyApi.updateAcademy(body, { mp_event_name: 'T21-02_학원정보수정_API' })
  }

  async getNiceEncodeInfo(params: NiceEncodeInfoParams) {
    return academyApi.getNiceEncodeData(params, { mp_event_name: 'T52-06_SMS핸드폰인증_API' })
  }

  async registerSmsPhoneNumberByNice(encodeData: string) {
    await academyApi.registerSmsPhoneNumberByNice(encodeData, {
      mp_event_name: 'T52-06_NICE인증발신번호등록_API',
    })
  }

  async fetchNiceIdentityForSettlement(encodeData: string) {
    return academyApi.getNiceIdentityForSettlement(encodeData, {
      mp_event_name: 'T52-06_NICE인증발신번호등록_API',
    })
  }

  postMetaData = async (body: AcademyInitializationBody) => {
    await academyApi.initializeAcademy(body, { mp_event_name: 'T21-02_내정보수정_API' })
  }
  patchMetaData = async (body: AcademyMetadataItemBody) => {
    await academyApi.updateAcademyMetadataItem(body, {
      mp_event_name: 'T52-07_학원메타데이터수정_API',
    })
  }
  refetchAfterPutMetaData = async (body: AcademyInitializationUpdateBody) => {
    await academyApi.updateAcademyInitialization(body, {
      mp_event_name: 'T52-07_학원메타데이터수정_API',
    })
    commonRepo.academy = await this.fetchMyAcademy()
  }

  postFreePremium = async (body: FreePremiumBody) => {
    await academyApi.requestFreePremium(body, { mp_event_name: 'T21-02_프리미엄체험신청_API' })
  }

  getSettlementWithIdentification = async () => await podSettlementApi.getSettlementAccount()

  putAdditionalData = async (body: AcademyAdditionalDataBody) => {
    await academyApi.updateAcademyAdditionalData(body, { mp_event_name: 'T21-02_학원정보수정_API' })
  }

  postSubscriptionOffer = async (
    ...params: Parameters<typeof academyApi.requestSubscriptionOffer>
  ) => {
    await academyApi.requestSubscriptionOffer(...params)
  }
}

export const academyController = new AcademyController()
